const AUTH_STORAGE_KEY = "customer_auth";

export function getAuth() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAuth(authData) {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
  window.dispatchEvent(new Event("auth-changed"));
}

export function clearAuth() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  window.dispatchEvent(new Event("auth-changed"));
}

export function getAuthToken() {
  return getAuth()?.token || null;
}

export function getCurrentCustomer() {
  return getAuth()?.customer || null;
}

export function isAuthenticated() {
  return !!getAuthToken();
}
